schoolwork12.app.student.templates.studentCreTracking = "ng-migration/student/components/student-cre.html";
schoolwork12.app.student.routes.cre = "/cre-tracking";
schoolwork12.app.student.services.studentSearchDetailsNotification = 'studentSearchSearchNotification'; // Added already on student.js
schoolwork12.app.student.endpoints.creSummary =  (schoolId, studentId) => `/student/${studentId}/school/${schoolId}/creTracking`


